import React, { useState } from "react";
import { Share2, Copy, Link2, MessageCircle, Mail } from "lucide-react";
import { toast } from "sonner";

const INVITE_TEXT = (link) =>
  `I've been doing this lovely 30-minute Sunday ritual with my child. one story, one conversation, one activity, one reflection. It's called NeuroEQ. Maybe you'd like to try it with your kids?\n\n${link}`;

export function InviteFriends({ open, onClose }) {
  const link = `${window.location.origin}/?invited=1`;
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const text = INVITE_TEXT(link);

  const share = async () => {
    setBusy(true);
    try {
      if (navigator.share) {
        await navigator.share({ title: "NeuroEQ. a weekly family ritual", text, url: link });
      } else {
        await navigator.clipboard.writeText(text);
        toast.success("Invite copied. Paste anywhere.");
      }
    } catch {} finally { setBusy(false); }
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success("Invite copied"); } catch { toast.error("Could not copy"); }
  };
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(link); toast.success("Link copied"); } catch { toast.error("Could not copy"); }
  };
  const whatsapp = () => window.open(`https://wa.me/?text=${encodeURIComponent(text)}`);
  const email = () => window.location.href = `mailto:?subject=${encodeURIComponent("A 30-minute Sunday ritual with our kids")}&body=${encodeURIComponent(text)}`;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-end sm:items-center justify-center p-4 fade-in"
         data-testid="invite-modal" onClick={onClose}>
      <div className="card-elevated w-full max-w-md p-6 sm:p-8 rise-in" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-display text-2xl mb-1">Invite a friend</h3>
        <p className="text-sm text-muted-foreground mb-5">
          Know another parent who'd love a calm Sunday ritual? Send them a thoughtful invite.
        </p>

        <div className="card-soft p-4 mb-5">
          <p className="text-sm whitespace-pre-wrap">{text}</p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <button onClick={share} disabled={busy} className="btn-primary col-span-2" data-testid="invite-share-btn">
            <Share2 className="w-4 h-4"/> Share invite
          </button>
          <button onClick={whatsapp} className="btn-ghost" data-testid="invite-whatsapp-btn">
            <MessageCircle className="w-4 h-4"/> WhatsApp
          </button>
          <button onClick={email} className="btn-ghost" data-testid="invite-email-btn">
            <Mail className="w-4 h-4"/> Email
          </button>
          <button onClick={copy} className="btn-ghost" data-testid="invite-copy-btn">
            <Copy className="w-4 h-4"/> Copy text
          </button>
          <button onClick={copyLink} className="btn-ghost" data-testid="invite-link-btn">
            <Link2 className="w-4 h-4"/> Copy link
          </button>
        </div>

        <button onClick={onClose} className="text-xs text-muted-foreground mt-5 w-full text-center" data-testid="invite-close">
          Close
        </button>
      </div>
    </div>
  );
}
